// extracted by mini-css-extract-plugin
export default {"timeline_container":"timeline_timeline_container__W-NlQ","year_wrapper":"timeline_year_wrapper__Vz2Ta","timeline_item":"timeline_timeline_item__8dC50"};